<div fxFlex class="qr-code">
    <ngx-qrcode 
        [value]="qrCodeUrl" 
        [colorDark]="'#000000'"
        [colorLight]="'#ffffff'" 
        [width]="300">
    </ngx-qrcode>
</div>
